var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "close_small"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26116_196778",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26116_196778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close_small_2",
    d: "M9.1 16.2999C8.7134 16.6865 8.0866 16.6865 7.7 16.2999C7.3134 15.9133 7.3134 15.2865 7.7 14.8999L10.6 11.9999L7.70366 9.12368C7.31544 8.73815 7.31434 8.11056 7.70122 7.72368C8.08715 7.33776 8.71285 7.33776 9.09878 7.72368L12 10.6249L14.8774 7.72734C15.2623 7.33979 15.8888 7.3387 16.275 7.7249C16.6612 8.11111 16.6601 8.7376 16.2726 9.12246L13.375 11.9999L16.2762 14.9011C16.6621 15.287 16.6621 15.9128 16.2762 16.2987C15.8893 16.6856 15.2618 16.6845 14.8762 16.2962L12 13.3999L9.1 16.2999Z",
    fill: "#4F90A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2580268a86462139640636d36da0008d.svg";
export { ForwardRef as ReactComponent };